import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, limit } from 'firebase/firestore';
import { Phone, MessageCircle } from 'lucide-react';
import './QuickContact.css';
import { db } from '../firebase/firebase-config';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const QuickContact = () => {
  const [contactInfo, setContactInfo] = useState(null);
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { lang } = useLanguage();

  useEffect(() => {
    const fetchQuickContact = async () => {
      try {
        const q = query(collection(db, "settings"), limit(1));
        const snap = await getDocs(q);
        if (!snap.empty) setContactInfo(snap.docs[0].data());
      } catch (error) {
        console.error("Hızlı iletişim verisi çekilemedi:", error);
      }
    };
    fetchQuickContact();
  }, []);

  const cleanPhone = contactInfo?.phone?.replace(/\s/g, '') || "905520262568";

  // WhatsApp mesajını dile göre (TR, EN, AR) hazırlıyoruz kanka
  const wpMessage = lang === 'TR' 
    ? "Merhaba, Bigma Yem hakkında bilgi almak istiyorum."
    : lang === 'AR'
    ? "مرحباً، أود الحصول على معلومات حول أعلاف بيغما."
    : "Hello, I would like to get information about Bigma Feed.";

  return (
    <>
      {/* SOL: ARAMA BUTONU */}
      <a 
        href={`tel:${cleanPhone}`} 
        className="quick-btn float-left-call" 
        title={lang === 'TR' ? "Bizi Arayın" : lang === 'AR' ? "اتصل بنا" : "Call Us"}
      >
        <div className="btn-icon"><Phone size={24} fill="white" /></div>
        <span className="btn-text">
          {lang === 'TR' ? "Hemen Ara" : lang === 'AR' ? "اتصل الآن" : "Call Now"}
        </span>
      </a>

      {/* SAĞ: WHATSAPP BUTONU */}
      <a 
        href={`https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodeURIComponent(wpMessage)}`} 
        target="_blank" 
        rel="noreferrer" 
        className="quick-btn float-right-wp" 
        title={lang === 'TR' ? "WhatsApp Destek" : lang === 'AR' ? "دعم واتساب" : "WhatsApp Support"}
      >
        <div className="btn-icon"><MessageCircle size={24} fill="white" /></div>
        <span className="btn-text">WhatsApp</span>
      </a>
    </>
  );
};

export default QuickContact;